import { render, staticRenderFns } from "./zytlgz.vue?vue&type=template&id=8f6e8794&scoped=true"
import script from "./zytlgz.vue?vue&type=script&lang=js"
export * from "./zytlgz.vue?vue&type=script&lang=js"
import style0 from "./zytlgz.vue?vue&type=style&index=0&id=8f6e8794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6e8794",
  null
  
)

export default component.exports